import { ServiceConfigurationV1 } from '@volkswagen-onehub/service-config-provider';
import { CarlineWithOffers, ReferenciaLegales } from 'src/types';
import { RegisteredDisclaimer } from 'src/feature-app';

export interface OffersState {
  offers?: CarlineWithOffers[];
  carline?: CarlineWithOffers;
  isSubmmiting?: boolean;
  referenciaLegales?: ReferenciaLegales[]
  disclaimers?: RegisteredDisclaimer[]
  isCallCenterOpen?: boolean;
}
export const initialState: OffersState = {
  offers: [],
  carline: null,
  isSubmmiting: false,
  referenciaLegales: [],
  disclaimers: [],
  isCallCenterOpen: false
};

export function offersReducer(state: any = initialState, action: any) {
  switch (action.type) {
    case 'UPDATE_STATE':
      return {
        ...state,
        ...action.payload,
      };
    case 'UPDATE_CARLINE':
      return {
        ...state,
        carline: action.payload,
      };
    case 'UPDATE_REFERENCIA_LEGALES':
      return {
        ...state,
        referenciaLegales: action.payload,
      };
    case 'UPDATE_DISCLAIMERS':
      return {
        ...state,
        disclaimers: action.payload,
      };
    case 'IS_CALL_CENTER_OPEN':
      return {
        ...state,
        isCallCenterOpen: action.payload,
      };
    case 'IS_SUBMITTING':
      return {
        ...state,
        isSubmmiting: action.payload,
      };
    default:
      return state;
  }
}
